module.exports = __webpack_public_path__ + "img/screener-copy.559f5a59.svg";